/** Registration view of the login page; the name mirrors the b2b app. */
export const REGISTER_ROUTE = '/register';
